import type { ReactNode } from 'react';
import { SnowflakeType } from '@/components/DeprecatedSnowflake/SnowflakeType';
import type { SubNavRoute } from '@/constants/routes';
import DesktopSidebar from '@components/DesktopSidebar';
import {
  COMPANY_VALUE_ANCHOR,
  COMPANY_FUTURE_ANCHOR,
  COMPANY_PAST_ANCHOR,
  COMPANY_HEALTH_ANCHOR,
  COMPANY_DIVIDEND_ANCHOR,
} from '@/constants/anchors';
import {
  DesktopSidebarWithSnowflakeWrapper,
  SnowflakeWrapper,
  ActionsWrapper,
  SidebarWrapper,
  Title,
  SubTitle,
} from './styled';
import loadable from '@loadable/component';

const Snowflake = loadable(() => import('@/components/DeprecatedSnowflake'));

const snowFlakeRoutes = [
  COMPANY_VALUE_ANCHOR,
  COMPANY_FUTURE_ANCHOR,
  COMPANY_PAST_ANCHOR,
  COMPANY_HEALTH_ANCHOR,
  COMPANY_DIVIDEND_ANCHOR,
];

interface Props {
  score: number[];
  selected: string;
  title?: string | null;
  routes: SubNavRoute[];
  subTitle?: string | null;
  handleClick?: () => void;
  children: ReactNode;
}

const DesktopSidebarWithSnowflake = ({
  title,
  score,
  routes,
  children,
  subTitle,
  selected,
  handleClick,
}: Props) => {
  return (
    <DesktopSidebarWithSnowflakeWrapper data-cy-id="desktop-sidebar-snowflake-wrapper">
      <SnowflakeWrapper data-cy-id="desktop-sidebar-snowflake">
        <Snowflake
          points={score}
          tooltip={true}
          routes={snowFlakeRoutes}
          handleClick={(route) => {
            window.location.hash = route;
          }}
          type={SnowflakeType.TOC}
        />
      </SnowflakeWrapper>
      {title && title.length > 0 && (
        <Title data-cy-id="desktop-sidebar-title">{title}</Title>
      )}
      {subTitle && subTitle.length > 0 && (
        <SubTitle data-cy-id="desktop-sidebar-subtitle">{subTitle}</SubTitle>
      )}
      {children && <ActionsWrapper>{children}</ActionsWrapper>}
      <SidebarWrapper>
        <DesktopSidebar
          fixed={false}
          selected={selected}
          routes={routes}
          listType="ol"
          handleClick={handleClick}
        />
      </SidebarWrapper>
    </DesktopSidebarWithSnowflakeWrapper>
  );
};

export default DesktopSidebarWithSnowflake;
